import React, {
  Dispatch,
  useCallback,
  useEffect,
  useState,
  useRef,
} from "react";

import "../../styles/requestMarketPlace.css";
import { FilePaste } from "../../components/CreateRequestPage/createRequest";
import { useDispatch, useSelector } from "react-redux";
import Select, { OptionTypeBase } from "react-select";

import helppeopleIcon from "../../assets/images/Logo-helppeople-2021-favicon.png";

import {
  SubmitButtons,
  NormalInput,
  ProductImage,
  AdjuntarArchivo,
  InputSearch,
  NormalInputsFields,
} from "../../components/MarketPlace/requestMarketPlace";

import { TextEditor } from "../../components/widgets/RichTextEditor";

import Tooltip from "../../components/widgets/Tooltip";

import MarketPlaceStore, {
  cleanStore,
  createProductRequest,
  createProductRequestFromTemplate,
  createProductRequestFromRule,
  createProductRequestFromFlow,
  getGuideTemplate,
  getTemplate,
  marketPlace,
  getUsersBasic,
  setUsers,
  searchUser,
  getCISAll,
  setShowCiStore,
  setCiTableInformation,
  setShowCiTable,
  setCISerialSelected,
} from "../../store/modules/MarketPlaceStore";

import { validateFile } from "../../store/modules/RuleStore";

import { Adjuntar } from "../../components/svg/Adjuntar";

import { user } from "../../store/modules/UserStore";
import { Redirect, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { MarketPlaceRequest } from "../../interfaces/MarketPlaceRequest";
import {
  ComponentId,
  FormAnswerPayload,
  FormsResult,
  Preguntas,
} from "../../interfaces/DynamicForms";

import API from "../../services/API";
import { TokenService } from "../../services/LocalStorage";

import addCiIcon from "../../assets/icons/add.svg";
import deleteCI from "../../assets/images/iconDeleteRed.png";

import CisTable from "../../components/CIS/cisTable";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../components/Multilanguage/TranslatableText";
import { useTranslationContext } from "../../context/TranslationContext";

const RequestMarketPlace = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const marketStore = useSelector(marketPlace);

  const { t } = useTranslation();

  const { translateText, targetLang } = useTranslationContext();
const[AdjSize,setAdjSize] = useState<number>(20);
const[excludedExtensions,setExcludedExtensions] = useState<string[]>([".cmd"]);
  const [newOnbehalfto, setOnbehalfto] = useState("");
  const [showListUsers, setShowListUsers] = useState(false);
  const [showCIS, setShowCIS] = useState(false);
  const userStore = useSelector(user);
  const [forms, setForms] = useState<FormsResult>();
  const [translatedForm, setTranslatedForm] = useState<Preguntas[] | undefined>([]);
  const [formsAnswer, setFormsAnswer] = useState<{ [key: string]: any }>({});
  const selectInputRef = useRef<any>();

  const [boot,setBoot] = useState<boolean>(false);

  const [subject, setSubject] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [ciiOrName, setCiiOrName] = useState<string>("");
  const [typeCi, setTypeCi] = useState<number>();
  const [attachment, setAttachment] = useState<File[]>([]);
  const [attachmentForm, setAttachmentForm,] = useState<Record<number, any[]>>({});


  const TABLE_HEAD = [t("cis.name"), t("cis.usedBy"), t("cis.location"), ""];

  const handleSubject = (subject: string): void => {
    setSubject(subject);
  };

  const checkForTemplate = useCallback(() => {
    const templateId = marketStore.selectedProduct?.ProductTemplateId;
    const guideTemplateId = marketStore.selectedProduct?.ProductGuideId;

    if (templateId && templateId > 0) {
      const serviceId = marketStore.selectedProduct?.ProductServiceId || 0;
      dispatch(getTemplate(serviceId));
    } else if (guideTemplateId && guideTemplateId > 0) {
      dispatch(getGuideTemplate(guideTemplateId));
    }
  }, [
    dispatch,
    marketStore.selectedProduct?.ProductGuideId,
    marketStore.selectedProduct?.ProductServiceId,
    marketStore.selectedProduct?.ProductTemplateId,
  ]);

  const checkForms = useCallback(() => {
    if (!marketStore.selectedProduct) return;

    const productFromId: number =
      marketStore.selectedProduct.ProductAttachedFormId;

    if (productFromId < 1) return;

    API()
      .post("Formulario/GetForms", {
        Token: TokenService.get(),
        FormId: marketStore.selectedProduct?.ProductAttachedFormId,
      })
      .then(async (response: any) => {
        if (response.data.Values.length > 0) {
          setForms(response.data.Values[0]);
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }, [marketStore.selectedProduct]);


useEffect(() => {
  const stored = localStorage.getItem("userInfo");
     
      setAdjSize(stored ? JSON.parse(stored).Maxadj : 20)

      setExcludedExtensions(stored ? JSON.parse(stored).Ext : [ ".cmd"]);
},[])
  // Informacion de los formularios
  useEffect(() => {
     
     
    checkForTemplate();
    checkForms();
    return () => {
      dispatch(cleanStore());
    };
  }, [checkForTemplate, checkForms, dispatch]);

  useEffect(() => {
    const translateFields = async () => {
      const translatedFields: any = await Promise.all(
        forms!.preguntas.map(async (field) => {
          const translatedDetalle = field.detalle
            ? await translateText(field.detalle, "text")
            : field.detalle;
          return { ...field, detalle: translatedDetalle };
        })
      );
      setTranslatedForm(translatedFields);
    };

    // Traducir solo si el idioma no es español
    if (targetLang && targetLang !== "es" && forms) {
      translateFields();
    } else {
      setTranslatedForm(forms?.preguntas);
    }
  }, [forms, targetLang, translateText]);

    /////// Llamado a BootMultiple
  useEffect(() => {

     API()
  .get("Rules/getStatusBoot", {
    headers: {
      'x-helppeople-token': TokenService.get(),
    },
  })
  .then(async (response: any) => {
    console.log("response", response.data);
    if (response.data.Values) {
      setBoot(response.data.Values);
    }
  })
  .catch((e) => {
    console.error(e.message);
  });

   
  }, []);

  const limpiarNombreArchivo = (nombreOriginal: string): string => {
    return nombreOriginal
      .replace(/\+/g, "")              // quitar +
      .replace(/\(/g, "")              // quitar (
      .replace(/\)/g, "")              // quitar )
      .replace(/%/g, "")               // quitar %
      .replace(/#/g, "")               // quitar #
      .replace(/&/g, "")               // quitar &
      .replace(/'/g, "")               // quitar '
      .replace(/,/g, "")               // quitar ,
      .replace(/\s+/g, "_")            // reemplazar espacios por _
      .trim();                         // eliminar espacios al inicio/fin
  };
  

  const handleAttachmentUp = (files: any, append: boolean, id: number) => {

    setAttachmentForm((prevState) => ({
      ...prevState,
      [id]: append ? [...(prevState[id] || []), ...files] : [...files],
    }));
  };
  const handleAttachmentLoad = (selectorFiles: FileList,dynamic:boolean =false) => {
    const formData = new FormData();

    for (const name in selectorFiles) {
      formData.append(name, selectorFiles[name]);
    }

  const filesToUpload = [...attachment, ...Object.values(selectorFiles)];
  filesToUpload.map((item) => {
    setAttachment([...filesToUpload.filter((item) => item.size < 55000000)]);
  });

   
  };
 

  const handleAttachmentDelete = (index: number,dynamic:boolean =false,preguntaId :number =0): void => {
    let updateAttachment;

  
    updateAttachment = [...attachment];
    updateAttachment.splice(index, 1);
    setAttachment(updateAttachment);
  

  // Eliminar del estado formsAnswer si ya no quedan adjuntos
  if (updateAttachment.length === 0 && preguntaId >0) {
   
    setFormsAnswer((prevState) => {
      const newState = { ...prevState };
      delete newState[`campo${preguntaId}`]; // Elimina la clave si no hay adjuntos
      return newState;
    });
  }
};
const handleAttachmentDeleteDown = (index: number, dynamic: boolean, id: number) => {
  setAttachmentForm((prevState) => {
    const updatedFiles = [...(prevState[id] || [])]; // Copia la lista de archivos
    updatedFiles.splice(index, 1); // Elimina el archivo en la posición dada

    // Si la lista queda vacía, eliminamos la clave del estado para evitar arrays vacíos innecesarios
    const newState = { ...prevState };
    if (updatedFiles.length > 0) {
      newState[id] = updatedFiles;
    } else {
      delete newState[id];
    }

    return newState;
  });
};



  const addCISShow = () => {
    if (marketStore.showCi) {
      dispatch(setShowCiStore(false));
      // setShowCIS(false);
    } else {
      dispatch(setShowCiStore(true));
      // setShowCIS(true);
      dispatch(getCISAll(ciiOrName, typeCi, defaultUserLogin));
    }
  };

  const deleteCITable = (ciId: any) => {
    const newCiTableInformation = marketStore.ciTableInformation.filter(
      (value) => value.ciId !== ciId
    );

    dispatch(setCiTableInformation(newCiTableInformation));

    const newCISerialArray = marketStore.ciSerialSelected.filter(
      (value) => value.CIID !== ciId
    );

    dispatch(setCISerialSelected(newCISerialArray));

    if (newCiTableInformation.length === 0) {
      dispatch(setShowCiTable(false));
    }
  };

  const validateForms = (): boolean => {
  
    if (forms) {
  
      for (let index = 0; index < forms?.preguntas.length; index++) {
        const pregunta = forms?.preguntas[index];
        if (pregunta.IdComponente === 8) {
          const emailReguex: RegExp =
            /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,63}$/i;

          if (!emailReguex.test(formsAnswer[`campo${pregunta.id}`])) {
            showErrorMessage(t("cis.invalidForm"));

            return false;
          }
        }
        
        
        if (pregunta.requerido) {
       
         let valorCampo = formsAnswer[`campo${pregunta.id}`];
          if (typeof valorCampo === "string" && valorCampo.startsWith("adjunto")) {
             const numero = valorCampo.match(/\d+/);

              if (numero) {
                const id = numero[0];
             
                 const arr = attachmentForm[Number(id)];

                if (
                  Object.keys(attachmentForm).length === 0 ||  // attachmentForm vacío
                  !Array.isArray(arr) ||                      // el valor no es array
                  arr.length === 0                            // el array está vacío
                ) {
                  return false;
                }
              }
     
         }
          if (!formsAnswer[`campo${pregunta.id}`]) {
        
           
              return false;
            
            
          }
        }
      }
    }

    return true;
  };

  const showErrorMessage = (message: string): void => {
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleProductRequestCreation = (): void => {
    const ruleId: number | undefined =
      marketStore.selectedProduct?.ProductRuleId;
const resBoot = marketStore.selectedProduct?.ProductBootMultiple;
    
    const templateId: number | undefined =
      marketStore.selectedProduct?.ProductTemplateId;

    const flowId: number = marketStore.selectedProduct?.ProductFlowId || 0;

    // Creación de una solicitud cuando NO tiene habilitado el asunto y descripcion ademas de ser formulario
    if (
      forms &&
      marketStore.selectedProduct?.ProductName &&
      (marketStore.selectedProduct?.ProductDescriptionActive === false ||
        marketStore.selectedProduct?.ProductDescriptionActive === null)
    ) {
      if (defaultSelectUser.userLogin === "") {
        showErrorMessage(t("cis.completeFields"));
        return;
      }

      const files: File[] = attachment;
      const filesDinamico = attachmentForm;
      const productRequest: MarketPlaceRequest = {
        Subject: marketStore.selectedProduct.ProductName,
        Description: marketStore.selectedProduct.ProductDescription,
        OnBehalfTo: defaultSelectUser.userLogin,
        ServiceID: marketStore.selectedProduct?.ProductServiceId || 1,
        ThroughOf: "301",
        Nature: 4,
        file: files,
        fileDinamico:filesDinamico
      };


      if (!validateForms()) {
        showErrorMessage(t("cis.completeFields"));
        return;
      }

      let checkBoxanswers: any = [];
      const answers = forms.preguntas.map((item) => {
        switch (ComponentId[item.IdComponente]) {
          case "select":
            return {
              QuestionId: item.id,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`]?.props?.text,
            };
          case "radio":
            return {
              QuestionId: item.id,
              AnswerId: 0,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`],
            };
          case "checkbox":
            return {
              QuestionId: item.id,
              AnswerId: 0,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`].join(","),
            };

          default:
            return {
              QuestionId: item.id,
              AnswerId: 0,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`],
            };
        }
      });

      let formData: FormAnswerPayload = {
        Token: TokenService.get(),
        FormId: forms.id,
        RegisterResolvedBy: userStore.username,
        RegisterType: 1,
        FormType: 0,
        ResolvedQuestions: answers.concat(checkBoxanswers),
      };

      formData.ResolvedQuestions = formData.ResolvedQuestions.filter(function (
        element
      ) {
        return element !== undefined && element !== null;
      });

      createRequest(
        productRequest,
        ruleId ?? 0,
        templateId ?? 0,
        flowId,
        formData
      );
      return;
    }

    // Creación de una solicitud cuando tiene habilitado el asunto y descripcion ademas de ser formulario
    if (
      forms &&
      marketStore.selectedProduct?.ProductName &&
      marketStore.selectedProduct?.ProductDescriptionActive === true
    ) 
    {
      if (defaultSelectUser.userLogin === "") {
        showErrorMessage(t("cis.completeFields"));
        return;
      }

      if (subject === "") {
        showErrorMessage(t("cis.fillSubjectField"));
        return;
      }

      const files: File[] = attachment;

      const filesDinamico= attachmentForm;

      const productRequest: MarketPlaceRequest = {
        Subject: subject,
        Description: description,
        OnBehalfTo: defaultSelectUser.userLogin,
        ServiceID: marketStore.selectedProduct?.ProductServiceId || 1,
        ThroughOf: "301",
        Nature: 4,
        file: files,
        fileDinamico: filesDinamico
      };

      if (!validateForms()) {
        showErrorMessage(t("cis.completeFields"));
        return;
      } else if (
        (description !== "" && description === "<p><br></p>") ||
        description === ""
      ) {
        showErrorMessage(t("cis.completeFields"));
        return;
      }

      let checkBoxanswers: any = [];
      const answers = forms.preguntas.map((item) => {
        switch (ComponentId[item.IdComponente]) {
          case "select":
            return {
              QuestionId: item.id,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`]?.props?.text,
            };
          case "radio":
            return {
              QuestionId: item.id,
              AnswerId: 0,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`],
            };
          case "checkbox":
            return {
              QuestionId: item.id,
              AnswerId: 0,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`].join(","),
            };

          default:
            return {
              QuestionId: item.id,
              AnswerId: 0,
              ComponentId: item.IdComponente,
              Answer: formsAnswer[`campo${item.id}`],
            };
        }
      });

      let formData: FormAnswerPayload = {
        Token: TokenService.get(),
        FormId: forms.id,
        RegisterResolvedBy: userStore.username,
        RegisterType: 1,
        FormType: 0,
        ResolvedQuestions: answers.concat(checkBoxanswers),
      };

      formData.ResolvedQuestions = formData.ResolvedQuestions.filter(function (
        element
      ) {
        return element !== undefined && element !== null;
      });
      createRequest(
        productRequest,
        ruleId ?? 0,
        templateId ?? 0,
        flowId,
        formData
      );
      return;
    }

    const files: File[] = attachment;
   
    // Creación de solicitud sin formulario
    if (
      subject !== "" &&
      description !== "" &&
      description !== "<p><br></p>" &&
      defaultSelectUser.userLogin
    ) {
      let productRequest: MarketPlaceRequest = {
        Subject: subject,
        Description: description,
        OnBehalfTo: defaultSelectUser.userLogin,
        ServiceID: marketStore.selectedProduct?.ProductServiceId,
        ThroughOf: "301",
        Nature: 4,
        file: files,
     
      };

      createRequest(productRequest, ruleId ?? 0, templateId ?? 0, flowId);
    } else {
      showErrorMessage(t("cis.mustFill"));
      return;
    }
  };

  const removeList = (e: any) => {
    setShowListUsers(false);
  };

  document.addEventListener("click", function (e: any) {
    removeList(e);
  });

  const searchUser = (e: any) => {
    const searchOnbehalfto = e.target.value;

    setShowListUsers(true);

    setOnbehalfto(searchOnbehalfto);

    if (searchOnbehalfto === "") {
      setDefaultSelectUser({ fullName: "", userLogin: "" });
    }

    if (searchOnbehalfto === "") return;
    setDefaultSelectUser(searchOnbehalfto);
    dispatch(getUsersBasic(searchOnbehalfto));
  };

  const userNameComplete = userStore.name + " " + userStore.lastName;

  const defaultUserLogin = userStore.username;

  // const [userNameComplete, setUserNameComplete] = useState("");
  const [userName, setUserNameComplete] = useState<OptionTypeBase>({
    value: userNameComplete,
    label: userNameComplete,
  });

  const [defaultSelectUser, setDefaultSelectUser] = useState<searchUser>({
    fullName: userNameComplete,
    userLogin: defaultUserLogin,
  });

  const createRequest = (
    productRequest: MarketPlaceRequest,
    ruleId: number,
    templateId: number,
    flowId: number,
    formData?: FormAnswerPayload
  ) => {
    console.log(`regla ${ruleId}, template ${templateId}, flow ${flowId} ,arrayReglas ${JSON.parse(marketStore?.selectedProduct?.ProductBootMultiple || '[]')}`)
    
    if (  ruleId && ruleId > 0 && !boot)   {
      
       
        productRequest = {
          ...productRequest,
          ReglaID: ruleId,
        };
      

      //Validamos si es obligatorio el CI
      if (marketStore.selectedProduct?.ProductRequestCi) {
        if (marketStore.selectedProduct?.ProductRequiredCi) {
          if (marketStore.ciSerialSelected.length === 0) {
            return showErrorMessage(t("cis.isMandatoryCI"));
          } else if (marketStore.ciSerialSelected.length > 1) {
            return dispatch(
              createProductRequestFromRule(
                productRequest,
                formData,
                marketStore.ciSerialSelected
              )
            );
          }
        }

        //Si no es obligatorio el CI
        if (marketStore.ciSerialSelected.length > 0) {
          dispatch(
            createProductRequestFromRule(
              productRequest,
              formData,
              marketStore.ciSerialSelected
            )
          );
        } else {
          dispatch(createProductRequestFromRule(productRequest, formData, []));
        }
      } else {
        dispatch(createProductRequestFromRule(productRequest, formData, []));
      }
    }
    else if(boot && templateId <= 0 && flowId <= 0 ){

      var resp = JSON.parse(marketStore?.selectedProduct?.ProductBootMultiple || '[]')

      if (boot && Array.isArray(resp) && resp.length > 0) {

        productRequest = {
          ...productRequest,
          ReglaID: marketStore.selectedProduct?.ProductBootMultiple,
        };
      }
       //Validamos si es obligatorio el CI
      if (marketStore.selectedProduct?.ProductRequestCi) {
        if (marketStore.selectedProduct?.ProductRequiredCi) {
          if (marketStore.ciSerialSelected.length === 0) {
            return showErrorMessage(t("cis.isMandatoryCI"));
          } else if (marketStore.ciSerialSelected.length > 1) {
            return dispatch(
              createProductRequestFromRule(
                productRequest,
                formData,
                marketStore.ciSerialSelected
              )
            );
          }
        }

        //Si no es obligatorio el CI
        if (marketStore.ciSerialSelected.length > 0) {
          dispatch(
            createProductRequestFromRule(
              productRequest,
              formData,
              marketStore.ciSerialSelected
            )
          );
        } else {
          dispatch(createProductRequestFromRule(productRequest, formData, []));
        }
      } else {
        dispatch(createProductRequestFromRule(productRequest, formData, []));
      }

    }
     else if (templateId && templateId > 0) {
     
      productRequest = {
        ...productRequest,
        // StartDate: new Date(),
        TemplateID: templateId,
        StatusID: 1,
      };
      if (marketStore.selectedProduct?.ProductRequestCi) {
        if (marketStore.selectedProduct?.ProductRequiredCi) {
          if (marketStore.ciSerialSelected.length === 0) {
            return showErrorMessage(t("cis.isMandatoryCI"));
          } else if (marketStore.ciSerialSelected.length > 1) {
            return dispatch(
              createProductRequestFromTemplate(
                productRequest,
                formData,
                marketStore.ciSerialSelected
              )
            );
          }
        }

        if (marketStore.ciSerialSelected.length > 0) {
          // dispatch(
          //   createProductRequestFromRule(
          //     productRequest,
          //     formData,
          //     marketStore.ciSerialSelected
          //   )
          // );
          dispatch(
            createProductRequestFromTemplate(
              productRequest,
              formData,
              marketStore.ciSerialSelected
            )
          );
        } else {
          dispatch(
            createProductRequestFromTemplate(productRequest, formData, [])
          );

          // dispatch(createProductRequestFromRule(productRequest, formData, []));
        }
      } else {
        dispatch(
          createProductRequestFromTemplate(productRequest, formData, [])
        );

        // dispatch(createProductRequestFromRule(productRequest, formData, []));
      }
    } else if (flowId > 0) {
      
      const subjectDescriptionEnable =
        marketStore?.selectedProduct?.ProductDescriptionActive || false;

      productRequest.flowId = flowId;

      //Validamos si es obligatorio el CI
      if (marketStore.selectedProduct?.ProductRequestCi) {
        if (marketStore.selectedProduct?.ProductRequiredCi) {
          if (marketStore.ciSerialSelected.length === 0) {
            return showErrorMessage(t("cis.isMandatoryCI"));
          } else if (marketStore.ciSerialSelected.length > 1) {
            //  return dispatch(
            //     createProductRequestFromRule(
            //       productRequest,
            //       formData,
            //       marketStore.ciSerialSelected
            //     )
            //   );

            dispatch(
              createProductRequestFromFlow(
                productRequest,
                formData,
                marketStore.ciSerialSelected,
                subjectDescriptionEnable
              )
            );
          }
        }

        //Si no es obligatorio el CI
        if (marketStore.ciSerialSelected.length > 0) {
          dispatch(
            createProductRequestFromFlow(
              productRequest,
              formData,
              marketStore.ciSerialSelected,
              subjectDescriptionEnable
            )
          );
        } else {
          dispatch(
            createProductRequestFromFlow(
              productRequest,
              formData,
              [],
              subjectDescriptionEnable
            )
          );
        }
      } else {
        dispatch(
          createProductRequestFromFlow(
            productRequest,
            formData,
            [],
            subjectDescriptionEnable
          )
        );
      }
    } else {
      dispatch(createProductRequest(productRequest, formData));
    }
  };

  return (
    <>
  
      <div className="container grid grid-cols-3 gap-6">
        {marketStore.requestCreated && !marketStore.loading && (
          <Redirect to={`/request/${marketStore.requestCreatedId}`} />
        )}
        <div className="col-span-3 lg:col-span-1  md:col-span-1">
          <Link to={"/MarketPlace/index"}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 17L6 12M6 12L11 7M6 12L18 12"
                stroke="#111827"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
          <ProductImage>
            <img
              src={
                marketStore.selectedProduct?.ProductImage !== ""
                  ? marketStore.selectedProduct?.ProductImage
                  : "https://s3.us-west-2.amazonaws.com/developer.helppeoplecloud.com/Logo-helppeople-2021-favicon.png"
              }
              style={{ width: "80%" }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = helppeopleIcon;
              }}
              alt="productImage"
            />
          </ProductImage>
        </div>
        <div className="col-span-3 lg:col-span-2  md:col-span-2">
          <div className="grid grid-cols-3 gap-2">
            <div className="col-span-3 lg:col-span-2  md:col-span-2">
              <h1
                className="text-xl mt-2 text-azulMedio"
                style={{
                  overflowWrap: "break-word",
                  width: "90%",
                  overflow: "hidden",
                  whiteSpace: "pre-wrap",
                }}
              >
                <TranslatableText
                  text={marketStore.selectedProduct?.ProductName}
                />
              </h1>
              <p
                className="mt-2 text-justify"
                style={{
                  overflowWrap: "break-word",
                  width: "90%",
                  overflow: "hidden",
                  whiteSpace: "pre-wrap",
                }}
              >
                <TranslatableText
                  text={marketStore.selectedProduct?.ProductDescription}
                />
              </p>
            </div>
            <div className="col-span-3 lg:col-span-2  md:col-span-2">
              <label className="text-black-500 break-words mt-3 text-md">
                {t("cis.service")}:{" "}
                <span className="text-gray-500">
                  <TranslatableText
                    text={marketStore.selectedProduct?.ProductServiceName}
                  />
                </span>
              </label>
              <br />
              {/* <label className="text-black-500 break-words mt-3 text-md">
                Solicitante:
                <span className="text-gray-500">
                  {userStore.name} {userStore.lastName}
                </span>
              </label> */}
              <div
                style={{
                  display: marketStore.selectedProduct?.ProductVisibleCost
                    ? "contents"
                    : "none",
                }}
              >
                <label className="text-black-500 break-words mt-3 text-md">
                  {t("cis.cost")}:{" "}
                  <span className="text-gray-500">
                    {marketStore.selectedProduct?.ProductCost.toLocaleString(
                      "es-CO",
                      {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                      }
                    )}
                  </span>
                </label>
              </div>
              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="solicitante"
                >
                  {t("cis.onBehalfOf")}
                  <span className="text-red-600 text-md font-bold"> *</span>
                </label>
                <div className="contentInput" style={{ height: 20 }}>
                  <InputSearch
                    placeholder={t("cis.onBehalfOf")}
                    onChange={(e: any) => searchUser(e)}
                    maxLength="80"
                    value={defaultSelectUser.fullName}
                    type="search"
                  />
                  <div className="content-list-user">
                    {showListUsers && (
                      <div className="content">
                        {marketStore.list.map((users) => {
                          return (
                            <button
                              className="list-users"
                              onClick={() => {
                                if (users.userLogin) {
                                  setDefaultSelectUser({
                                    fullName: users.fullName,
                                    userLogin: users.userLogin,
                                  });
                                  setShowListUsers(false);
                                  dispatch(setUsers([]));
                                }
                              }}
                            >
                              {users.fullName}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </NormalInputsFields>
            </div>
            {forms ? (
              <>
                {/* Formularios dynamicos */}
                <div className="col-span-3 lg:col-span-2  md:col-span-2">
                  <h1>
                    <TranslatableText text={forms?.descripcion} />
                  </h1>
                </div>
                {/* incluir campo asunto y descripción si el producto esta previamente configurado para que se muestren */}

                {marketStore.selectedProduct?.ProductDescriptionActive ===
                  true && (
                  <>
                    <div className="col-span-3 lg:col-span-2  md:col-span-2">
                      <label className="w-full text-black-500 break-words mt-3 text-md">
                        {t("cis.subject")}{" "}
                        <span className="text-red-600 text-md font-bold">
                          *
                        </span>
                      </label>
                      <NormalInput
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleSubject(e.target.value)
                        }
                        maxLength={80}
                        value={subject}
                        type="text"
                        name="nameForm"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded"
                      />
                    </div>
                    <div
                      className="col-span-3 lg:col-span-2  md:col-span-2"
                      style={{ position: "static" }}
                    >
                      <label className="w-full text-black-500 break-words mt-3 text-md">
                        {t("cis.description")}{" "}
                        <span className="text-red-600 text-md font-bold">
                          *
                        </span>
                      </label>
                      <div className="nootranslate" translate="no" data-translate="no">
                        <TextEditor
                          setDescription={setDescription}
                          description={description}
                          />
                      </div>
                    </div>
                  </>
                )}

                {translatedForm?.map((pregunta) => {
                 
                  switch (ComponentId[pregunta.IdComponente]) {
                    
                    case "text":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <label className="w-full text-black-500 break-words mt-3 text-md">
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </label>
                          <NormalInput
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded"
                            type="text"
                            placeholder={pregunta.detalle}
                            value={formsAnswer[`campo${pregunta.id}`]}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              // const data = formsAnswer;
                              // data[`campo${pregunta.id}`] = e.target.value;

                              // setFormsAnswer(data);
                              setFormsAnswer((prevState) => ({
                                ...prevState,
                                [`campo${pregunta.id}`]: e.target.value,
                              }));
                            }}
                          />
                        </div>
                      );

                    case "email":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <label className="w-full text-black-500 break-words mt-3 text-md">
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </label>
                          <NormalInput
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded"
                            type="email"
                            placeholder={pregunta.detalle}
                            value={formsAnswer[`campo${pregunta.id}`]}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              // const data = formsAnswer;
                              // data[`campo${pregunta.id}`] = e.target.value;

                              // setFormsAnswer(data);
                              setFormsAnswer((prevState) => ({
                                ...prevState,
                                [`campo${pregunta.id}`]: e.target.value,
                              }));
                            }}
                          />
                        </div>
                      );

                    case "file":
              
                      return  <div
                      className="col-span-3 lg:col-span-2  md:col-span-2"
                      key={pregunta.id}
                    > <label className="w-full text-black-500 break-words mt-3 text-md">
       <TranslatableText text={pregunta.descripcion} />{" "}
       {pregunta.requerido ? (
         <span className="text-red-600 text-md font-bold">
           *
         </span>
       ) : null}
     </label>
     <div
                      className="col-span-3 lg:col-span-2  md:col-span-2"
                      style={{
                        border: "2px dashed #cfcfcf",
                        width: "40%",
                        padding: "6px",
                      }}
                    >
                     
                      <AdjuntarArchivo>
                        <span className="flex items-center justify-center">
                          <Adjuntar />
                        </span>
                        {t("cis.attachFile")}
                        <input
                          type="file"
                          multiple={true}
                          style={{ display: "none" }}
                          name={`adjunto${pregunta.id}`}
                          className="hidden"
                          onChange={(e) => {
                            if (e.target.files !== null) {
                              const maxSize = AdjSize * 1024 * 1024;

                              const validFiles = Array.from(e.target.files).filter((file) => {
                                
                                if (file.size > maxSize) {
                                  showErrorMessage( `${file.name} ${t("cis.fileSizeError")} ${AdjSize} mb`);
                                  return false;
                                }

                                const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
                                if (excludedExtensions.includes(fileExtension)) {
                                  showErrorMessage(`${file.name} ${t("cis.extencionError")} (${fileExtension})`);
                                  return false;
                                }

                                return true;
                              });

                              if (validFiles.length === 0) {
                                e.target.value = "";
                                return;
                              }

                              const cleanedFiles = validFiles.map((file) => {
                                const nombreLimpio = limpiarNombreArchivo(file.name);
                                return new File([file], nombreLimpio, { type: file.type });
                              });

                              handleAttachmentUp(cleanedFiles, true, pregunta.id);

                              setFormsAnswer((prevState) => ({
                                ...prevState,
                                [`campo${pregunta.id}`]: `adjunto${pregunta.id}`,
                              }));

                              e.target.value = "";
                            }
                          }}
                        />

                      
                      </AdjuntarArchivo>

                  
                    </div>
                    {attachmentForm[pregunta.id]?.map((file, index) => (
  <Tooltip key={`${pregunta.id}-${index}`} title={file?.name}>
    <div className="border rounded-sm border-gray-300 mt-2 max-h-12 w-full flex">
      <span className="h-full w-4/5 line-clamp-1 overflow-hidden overflow-ellipsis whitespace-nowrap">
        {file?.name}
      </span>
      <div className="relative group">
        <button
          className="border border-red-700 px-2 py-0 ml-2 text-red-700 rounded-md hover:text-black hover:border-black"
          type="button"
          onClick={() => handleAttachmentDeleteDown(index, true, pregunta.id)}
        >
          {t("deteleButton")}
        </button>
      </div>
    </div>
  </Tooltip>
))}

     </div>              

      
                    case "number":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <label className="w-full text-black-500 break-words mt-3 text-md">
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </label>
                          <NormalInput
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded"
                            type="number"
                            placeholder={pregunta.detalle}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              // const data = formsAnswer;
                              // data[`campo${pregunta.id}`] = e.target.value;

                              // setFormsAnswer(data);
                              setFormsAnswer((prevState) => ({
                                ...prevState,
                                [`campo${pregunta.id}`]: e.target.value,
                              }));
                            }}
                          />
                        </div>
                      );
                    case "textarea":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <label className="w-full text-black-500 break-words mt-3 text-md">
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </label>
                          <textarea
                            className="border border-gray-300 rounded-md mx-1 p-2 w-full focus:border-blue-400 z-0"
                            // value={description}
                            maxLength={2000}
                            placeholder={pregunta.detalle}
                            rows={6}
                            cols={50}
                            onChange={(e) => {
                              // const data = formsAnswer;
                              // data[`campo${pregunta.id}`] = e.target.value;

                              // setFormsAnswer(data);
                              setFormsAnswer((prevState) => ({
                                ...prevState,
                                [`campo${pregunta.id}`]: e.target.value,
                              }));
                            }}
                          />
                        </div>
                      );
                    case "date":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <label className="w-full text-black-500 break-words mt-3 text-md">
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </label>
                          <NormalInput
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded"
                            type="date"
                            placeholder={pregunta.detalle}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              const data = formsAnswer;
                              data[`campo${pregunta.id}`] = e.target.value;

                              setFormsAnswer(data);
                            }}
                          />
                        </div>
                      );
                    case "checkbox":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <h1>
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </h1>
                          {pregunta.opciones.map((opcion) => {
                            return (
                              <div className="w-full" key={opcion.Value}>
                                <label className="w-full text-black-500 break-words mt-3 text-md">
                                  <TranslatableText text={opcion.Text} />{" "}
                                </label>
                                <input
                                  className="mt-1 shadow-sm  rounded-md"
                                  type="checkbox"
                                  placeholder={pregunta.detalle}
                                  value={opcion.Text.toString()}
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    const data = formsAnswer;
                                    if (data[`campo${pregunta.id}`] == null) {
                                      data[`campo${pregunta.id}`] = [];
                                    }
                                    if (
                                      data[`campo${pregunta.id}`].includes(
                                        value
                                      )
                                    ) {
                                      data[`campo${pregunta.id}`] = data[
                                        `campo${pregunta.id}`
                                      ].filter(function (item: any) {
                                        return item !== value;
                                      });
                                    } else {
                                      data[`campo${pregunta.id}`].push(value);
                                    }

                                    setFormsAnswer(data);
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      );
                    case "radio":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <h1>
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            {pregunta.requerido ? (
                              <span className="text-red-600 text-md font-bold">
                                *
                              </span>
                            ) : null}
                          </h1>
                          {pregunta.opciones.map((opcion) => {
                            return (
                              <div className="w-full" key={opcion.Value}>
                                <label className="w-full text-black-500 break-words mt-3 text-md">
                                  <TranslatableText text={opcion.Text} />{" "}
                                </label>
                                <input
                                  name={`campo${pregunta.id}`}
                                  type="radio"
                                  value={opcion.Text.toString()}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    const { value, name } = e.target;
                                    const data = formsAnswer;
                                    data[name] = value;
                                    setFormsAnswer(data);
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      );
                    case "select":
                      return (
                        <div
                          className="col-span-3 lg:col-span-2  md:col-span-2"
                          key={pregunta.id}
                        >
                          <label className="w-full text-black-500 break-words mt-3 text-md">
                            <TranslatableText text={pregunta.descripcion} />{" "}
                            <span className="text-red-600 text-md font-bold">
                              *
                            </span>
                          </label>
                          <Select
                            defaultValue={[
                              {
                                value: "s",
                                label:
                                  pregunta.detalle !== "" ? (
                                    <TranslatableText text={pregunta.detalle} />
                                  ) : (
                                    t("marketplace.select")
                                  ),
                              },
                            ]}
                            options={pregunta.opciones.map((opcion) => {
                              return {
                                value: opcion.Value.toString(),
                                label: (
                                  <TranslatableText text={opcion.Text} />
                                ) as any,
                              };
                            })}
                            onChange={(e) => {
                              const data = formsAnswer;
                              data[`campo${pregunta.id}`] = e?.label;
                              setFormsAnswer(data);
                            }}
                            ref={selectInputRef as any}
                          />
                        </div>
                      );
                    default:
                      return (
                        <div>
                          <p></p>
                        </div>
                      );
                  }
                })}
              </>
            ) : (
              <>
                <div className="col-span-3 lg:col-span-2  md:col-span-2">
                  <label className="w-full text-black-500 break-words mt-3 text-md">
                    {t("cis.subject")}{" "}
                    <span className="text-red-600 text-md font-bold">*</span>
                  </label>
                  <NormalInput
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleSubject(e.target.value)
                    }
                    maxLength={80}
                    value={subject}
                    type="text"
                    name="nameForm"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded"
                  />
                </div>
                <div
                  className="col-span-3 lg:col-span-2  md:col-span-2"
                  style={{ position: "static" }}
                >
                  <label className="w-full text-black-500 break-words mt-3 text-md">
                    {t("cis.description")}{" "}
                    <span className="text-red-600 text-md font-bold">*</span>
                  </label>
                  <div className="nootranslate" translate="no" data-translate="no">
                    <TextEditor
                      setDescription={setDescription}
                      description={description}
                    />
                  </div>
                </div>
              </>
            )}
            {/* Boton de subir documento */}
            <div className="col-span-3 lg:col-span-2  md:col-span-2">
              <div
                className="w-full"
                style={{
                  display: marketStore.selectedProduct
                    ?.ProductMandatoryAttachment
                    ? "contents"
                    : "none",
                }}
              >
                {t("cis.attach")}{" "}
                <span className="text-red-600 text-md font-bold"></span>
                <div
                  className=""
                  style={{
                    border: "2px dashed #cfcfcf",
                    width: "40%",
                    padding: "6px",
                  }}
                >
                  <AdjuntarArchivo>
                    <span className="flex items-center justify-center">
                      <Adjuntar />
                    </span>
                    {t("cis.attachFile")}
                    <input
                      type="file"
                      multiple={true}
                      style={{ display: "none" }}
                      name="adjunto"
                      className="hidden"
                      onChange={(e) => {
                        if (e.target.files !== null) {
                          handleAttachmentLoad(e.target.files);
                        }
                      }}
                    />
                    {/* <FilePaste
                      files={attachment}
                      setFiles={setAttachment}
                      handleChange={handleAttachmentLoad}
                    /> */}
                  </AdjuntarArchivo>
                </div>
                {attachment.map((attachment, index) => (
                  <Tooltip title={`${attachment?.name}`}>
                    <div
                      key={index}
                      className="border rounded-sm border-gray-300 mt-2 max-h-12 w-full flex"
                    >
                      <span className="h-full w-4/5 line-clamp-1 overflow-hidden overflow-ellipsis whitespace-nowrap">
                        {attachment?.name}
                      </span>
                      <div
                        className="relative group"
                        style={{
                          display: attachment !== null ? "contents" : "none",
                        }}
                      >
                        <button
                          className="border border-red-700 px-2 py-0 ml-2 text-red-700 rounded-md hover:text-black hover:border-black"
                          type="button"
                          onClick={() => handleAttachmentDelete(index)}
                        >
                          {t("deteleButton")}
                        </button>
                      </div>
                    </div>
                  </Tooltip>
                ))}
              </div>
            </div>
            <div className="col-span-3 lg:col-span-2  md:col-span-2">
              {marketStore.selectedProduct?.ProductRequestCi ? (
                <div>
                  <label className="w-full text-black-500 break-words mt-3 text-md">
                    {t("cis.associateAssetMin")}:
                  </label>
                  <div>
                    <button onClick={addCISShow}>
                      <div style={{ display: "flex" }}>
                        <img
                          src={`${addCiIcon}`}
                          alt=""
                          style={{ width: "20px" }}
                        />
                        <p style={{ color: "#545cd8", marginLeft: "4px" }}>
                          {t("cis.active")}
                        </p>
                      </div>
                    </button>
                  </div>
                  {marketStore.showCi ? <CisTable></CisTable> : ""}

                  {marketStore.showCiTable ? (
                    <div className="relative overflow-x-auto">
                      <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                          {TABLE_HEAD.map((head) => (
                            <th key={head} className="px-6 py-3">
                              {head}
                            </th>
                          ))}
                        </thead>
                        <tbody>
                          {marketStore.ciTableInformation.map(
                            ({ ciId, ciName, usedBy, location }, index) => {
                              return (
                                <tr
                                  key={ciId}
                                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                >
                                  <td
                                    scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                  >
                                    <TranslatableText text={ciName} />
                                  </td>{" "}
                                  <td
                                    scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                  >
                                    {usedBy}
                                  </td>{" "}
                                  <td
                                    scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                  >
                                    <TranslatableText text={location} />
                                  </td>
                                  <td
                                    scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                  >
                                    <div>
                                      <button
                                        onClick={() => {
                                          deleteCITable(ciId);
                                        }}
                                      >
                                        <div style={{ display: "flex" }}>
                                          <img
                                            src={`${deleteCI}`}
                                            alt=""
                                            style={{
                                              minWidth: "20px",
                                              maxWidth: "25px",
                                            }}
                                          />
                                          <p
                                            style={{
                                              color: "#545cd8",
                                              marginLeft: "4px",
                                            }}
                                          ></p>
                                        </div>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}

              <span className="text-gray-500"></span>
            </div>
            
            <div className="col-span-3 lg:col-span-2  md:col-span-2">
              {marketStore.loading && marketStore.isCallingServer ? (
                <p>{t("cis.sendingRequest")}...</p>
              ) : (
                <SubmitButtons
                  type={"button"}
                  onClick={handleProductRequestCreation}
                  disabled={marketStore.isCallingServer}
                >
                  {t("cis.request")}
                </SubmitButtons>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
    </>
  );
};

export default RequestMarketPlace;
